import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import EArchiveTableFilter from "../Filters/EArchiveTableFilter";
import FirmAddForm from "../Forms/FirmAddForm";
import { ColumnHelper } from "util/TableHelper";
import Replace2x from "../../util/Extensions/ReplaceExtension";

import { Table, Empty, Drawer, Col, Row, Modal, Tooltip, notification, Button,message,Form,Input } from "antd";
import { BarsOutlined, FilePdfOutlined,WarningOutlined, ExclamationCircleOutlined, SendOutlined } from "@ant-design/icons";
import { defaultValidateMessages } from "../Forms/Helper";
import config from "../../util/ApiforContext";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span:6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};

const EArchiveList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [addVisible, setAddVisible] = useState(true);
  const [totalAmount, setTotalAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [firmName, setFirmName] = useState();
  const [vkn, setVkn] = useState();
  const [tckn, setTckn] = useState();
  const [addFirmDrawerVisible, setAddFirmDrawerVisible] = useState(false);
  const [defaultMail, setDefaultMail] = useState("");
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });

  const [form] = Form.useForm();
  const [sendMailModal, setSendMailModal] = useState({
    visible: false,
    data: null
  });
  const [mailLoading, setMailLoading] = useState(false);

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/EArchive?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });

    RequestHandler.get(
      `/EArchive/GetTotal?$count=true&${getFilterQuery()}&$select=totalAmount`
    ).then((response) => {
      const total = response.reduce((accumulator, item) => accumulator + item.totalAmount, 0);
    setTotalAmount(ColumnHelper.renderDecimal(total))
    });
  };
  const pdfError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Pdf oluşturulamadı.",
      duration: 2,
    });
  };
  const downloadPdf = (id) => {
    const hide = message.loading('Pdf Açılıyor...', 0);
      setTimeout(hide, 2000);
    RequestHandler.get(
      `/EArchive/GetArchivePdf/${id}`
    ).then((response) => {
      if(response === ""){
        pdfError("error")
      }
      else{
        window.open(
          `${config.apiUrl
          }/EArchive/DownloadEArchive?fileName=${response}&t=${Replace2x(
            localStorage.getItem("token")
          )}`);
      }

    });
  };
  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const downloadArchivePdf = (id) => {
    const hide = message.loading('Pdf Açılıyor...', 0);
      setTimeout(hide, 2000);
        window.open(
          `${config.eInvoiceUrl
          }EInvoiceReceivedPdf/${id}.pdf`);
  };

  const sendPdfMail = () => {
    const hide = message.loading('Mail gönderiliyor...', 0);
      setTimeout(hide, 2000);
    RequestHandler.get(
      `/EArchive/GetArchivePdf/${sendMailModal.data.id}`
    ).then((response) => {
      if(response === ""){
        pdfError("error")
      }
      else{
        RequestHandler.post(
          `/EArchive/SendEArchiveMail`,
          {
            Filename: response,
            Email: defaultMail,
            Token: Replace2x(
              localStorage.getItem("token")
            )
          },
          true
        ).then((response) => {
          if(!response.success){
            pdfError("error");
          }
          else{
            setSendMailModal({visible: false, data: null});
          }
          setLoading(false);
        })
      }
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const renderRowDetail = ({ columns, data }) => {
    return (
      <p>
        {columns.map((column, index) => (
          <p key={index} style={{ marginBottom: ".25em" }}>
            <b>{column.title} : </b>{" "}
            {column.render
              ? column.render(data[column.dataIndex], data, index)
              : data[column.dataIndex]}
          </p>
        ))}
      </p>
    );
  };
  const showDrawer = (firmName,vkn,tckn) => {
    setFirmName(firmName)
    setVkn(vkn)
    setTckn(tckn)
    setAddFirmDrawerVisible(true);
  };

  const onClickSendMail = (pdfId) => {
    setSendMailModal({visible : true, data: {id : pdfId}})
  };

  const onClose = () => {
    setAddFirmDrawerVisible(false);
  };
  const firmNameText = "Firma tanımlı değil. Eklemek için tıklayın."
  const tableColumns = [
    {
      title: "Fatura Numarası",
      align:"center",
      dataIndex: "eInvoiceNumber",
    },
    {
      title: "Cari",
      dataIndex: "firmName",
      render: (text, row, index) => {
        return (
          <> {row.isExistFirm != true ?
          <> <Tooltip placement="rightBottom" title={firmNameText}>{row.firmName} <a onClick={() => {showDrawer(row.firmName,row.vkn,row.tckn)}} style={{ color: "red", fontSize: "130%" }}><WarningOutlined /></a></Tooltip> </>
          : row.firmName}
          </>
        );
      },
    },
    {
      title: "Senaryo",
      dataIndex: "senario",
    },
    {
      title: "Vkn/Tckn",
      dataIndex: "vkn",
      align:"center",
      key: "vkn",
      render: (text, row, index) => {
        return (
          row.vkn == null ? row.tckn : row.vkn
        );
      },
    },
    {
      title: "Fatura Tipi",
      align:"center",
      dataIndex: "type",
    },
    {
      title: "Toplam Tutar",
      dataIndex: "totalAmount",
      align:"center",
      render: ColumnHelper.renderDecimal,
    },
     {
      title: "Tarih",
      dataIndex: "date",
      align: "center",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Durum",
      align:"center",
      dataIndex: "status",
      render: (data, row, index) => {
       return <Tooltip placement="topLeft" title={data}>
        <div style={{ whiteSpace: "break-spaces" }}>
          {data?.substring(0, 50) === undefined
            ? " "
            : data?.trim().length <= 50
              ? data + ""
              : data?.substring(0, 50) + "..."}
        </div>
      </Tooltip>
      },
    },
    {
      title: "Pdf",
      align:"center",
      dataIndex: "invoiceData",
      render: (data, row, index) => {
        if( (row.invoiceData != null && row.eInvoiceProgramId == 2) || row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 1){
          return <a onClick={() => {downloadPdf(row.id)}}><FilePdfOutlined style={{fontSize:'140%',color:'darkRed'}} /></a>;
        }
        else if (row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 3){
          return <a onClick={() => {downloadArchivePdf(row.invoiceNoId)}}><FilePdfOutlined style={{fontSize:'140%',color:'darkRed'}} /></a>;
        }
      }
    },
    {
      title: "Mail",
      align: "center",
      dataIndex: "archiveMail",
      render: (data,row,index) => {
        return <a onClick={() => {onClickSendMail(row.id)}}><SendOutlined/></a>
      }
    }
  ];
  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };
  const onClickAddPlan = () =>{
    const filteredRows = selectedRows.data.filter(row => row.firmId === null);
  if(filteredRows.length > 0){
          Modal.confirm({
            title: "Uyarı!",
            icon: <ExclamationCircleOutlined />,
            content:
              "Cari eşleştirmesi olmayan kayıtlar var. Bu kayıtlar için Cari ‘Diğer’ olarak atanır. Devam etmek istiyor musunuz ?",
            okText: "Tamam",
            cancelText: "Vazgeç",
            onOk() {
              RequestHandler.post(`/MonthlyPlan/EArchiveAddPlan`, {
                eInvoiceIds: selectedRows.keys
              }).then((response) => {
                if (response.success) {
                setTimeout(() => {
                  window.location.reload();
                }, 1500);
                }
              });
            },
          });
    }else{
      RequestHandler.post(`/MonthlyPlan/EArchiveAddPlan`, {
        eInvoiceIds: selectedRows.keys
      }).then((response) => {
        if (response.success) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      });
    }
  }
  const detailEInvoiceItem = (data) => {
    const columns = [
      {
        title: "Satış Kodu",
        dataIndex: "salesCode",
      },
      {
        title: "Ürün Adı",
        dataIndex: "productName",
      },
      {
        title: "Adet",
        align:"center",
        dataIndex: "productCount",
      },
      {
        title: "Kdv Oranı",
        align:"center",
        dataIndex: "kdvPercent",
        render: (data, row, index) => data,
      },
      {
        title: "Birim Tutarı",
        align:"center",
        dataIndex: "amount",
        render: ColumnHelper.renderDecimal,
      },
      {
        title: "Kdv Dahil Birim Tutarı",
        align:"center",
        dataIndex: "amountWithKdv",
        render: (data, row, index) => data,
      },


    ];
    return (
      <Table

        columns={columns}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
          ),
        }}
        rowKey="EInvoiceItems"
        filterable={true}
        sortable={true}
        pagination={false}
        dataSource={data}
        size="small"
      />
    );
  };
  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> E-ARŞİV LİSTESİ
          </p>
        </Col>

        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
        {
          addVisible ?
          <>
           <a onClick={() => {onClickAddPlan()}}>
          <Button
            style={{ marginRight: 15 }}
            loading={loadingPlan}
            type='primary'
            disabled={selectedRows.keys.length > 0 ? false : true}
          >
             Plana Ekle
          </Button>
          </a>

          <a href="/create-earchive" onClick={() => {setLoading(true)}}>
          <Button
            style={{ marginRight: 15 }}
            loading={loading}
            type='primary'
          >
            E-Arşiv Ekle
          </Button>
          </a>

          </>

          :
          <a onClick={() => {onClickAddPlan()}}>
          <Button
            style={{ marginRight: 15 }}
            loading={loadingPlan}
            type='primary'
            disabled={selectedRows.keys.length > 0 ? false : true}
          >
             Plana Ekle
          </Button>
          </a>
         }
        </Col>
      </Row>

      <EArchiveTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
<div style={{textAlignLast:'end'}}><strong>Toplam Tutar : {totalAmount}</strong></div>
      <Row id="tableArea">
        <Col span={24}>
          <Table
           rowSelection={{
            selectedRowKeys: selectedRows.keys,
            onChange: onTableSelectChange,
            getCheckboxProps: (record) => ({
              disabled: record.isSendMonthlyPlan,
            }),
          }}
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            // expandable={{
            //     expandedRowRender: (row) => detailEInvoiceItem(row.eArchiveItems),
            //   }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
      <Drawer
        title="Cari Ekle"
        width={241}
        onClose={onClose}
        visible={addFirmDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        <FirmAddForm IsEarchive={true} SenderName={firmName} Tckn={tckn} Vkn={vkn} />
      </Drawer>
      <Modal
        id="sendMail"
        centered
        visible={sendMailModal.visible}
        onCancel={() => setSendMailModal({visible: false, data: null})}
        footer={null}
      >
        <Form
        {...formItemLayout}
        validateMessages={defaultValidateMessages}
        form={form}
        name="sendMail"
        initialValues={{
          remember: true,
        }}
        onFinish={() => sendPdfMail()}
        onFinishFailed={() => setLoading(false)}
        fields={[
          {name:"email",value:defaultMail}
        ]}
        >
          <Row>
            <Col span={24}>
              <Form.Item name="id" hidden>
                <Input/>
              </Form.Item>
              <Form.Item
                label="E-Posta"
                name="email"
                rules={[{required: true, type: "email"}]}
              >
                <Input value={defaultMail} onChange={(text) => {setDefaultMail(text.target.value)}} disabled={mailLoading} />
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<SendOutlined/>}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Gönder
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default EArchiveList;
